// Dismissing the Android tester banner (layouts/_android_test_banner) remembers it for a year, on every page
document.addEventListener('click', function(e) {
  if (e.target.closest && e.target.closest('.android-test-notice .close')) {
    document.cookie = 'android_test_notice_dismissed=1; max-age=31536000; path=/; SameSite=Lax';
  }
});
